import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  DataService,
  FormInputComponent,
  GetAdministratorListDocument,
  GetAdministratorListQuery,
  GetCurrentUserQuery,
  I18nService,
  InputComponentConfig,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Observable, take, map, takeUntil, Subject } from "rxjs";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";

@Component({
  selector: "custom-admin-selector",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./user-select.component.html",
})
export default class AssigneeComponent
  implements FormInputComponent, OnInit, OnDestroy
{
  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    this.adminList$ = this.dataService
      .query(GetAdministratorListDocument)
      .single$.pipe(
        take(1),
        map((d) => d.administrators.items)
      );
    this.dataService.auth
      .currentUser()
      .single$.pipe(takeUntil(this.destroy$))
      .subscribe((u) => {
        this.me = u.me;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  customSearchFn(
    term: string,
    item: { firstName: string; lastName: string }
  ): boolean {
    const searchTerm = term.toLowerCase();
    return (
      item.firstName.toLowerCase().includes(searchTerm) ||
      item.lastName.toLowerCase().includes(searchTerm)
    );
  }

  renderMe(user: GetAdministratorListQuery["administrators"]["items"][0]) {
    if (user.id === "") return null;
    if (this.me) {
      if (user.id === this.me.id) {
        return `${user.firstName} ${
          user.lastName
        } (${this.i18NService.translate("ticket.me")})`;
      }
    }
    return `${user.firstName} ${user.lastName}`;
  }

  constructor(
    protected dataService: DataService,
    private i18NService: I18nService
  ) {}
  isListInput?: boolean;
  readonly: boolean;
  formControl: FormControl<any>;
  config: InputComponentConfig;
  adminList$: Observable<GetAdministratorListQuery["administrators"]["items"]>;
  me: GetCurrentUserQuery["me"];
}
